import { render, staticRenderFns } from "./MessageInbox.vue?vue&type=template&id=99a66658&scoped=true"
import script from "./MessageInbox.vue?vue&type=script&lang=js"
export * from "./MessageInbox.vue?vue&type=script&lang=js"
import style0 from "./MessageInbox.vue?vue&type=style&index=0&id=99a66658&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "99a66658",
  null
  
)

export default component.exports